// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ke_ZkBj97kTIznQJQIq9{--titled-row-action-width:420px;padding:16px 20px 20px}.h9ZpMyfbMEoPjI__QQzT{flex-direction:column;display:flex}.iiZ7Kh0ArD0jgGA7ntCK{border-bottom:1px solid var(--border-neutral-default);grid-template-columns:280px 1fr;padding:16px 0}.iiZ7Kh0ArD0jgGA7ntCK:last-child{margin-bottom:24px}.qDOT71J2AvMG0UocBOAu{align-items:center;height:40px;padding:8px 8px 8px 12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ke_ZkBj97kTIznQJQIq9`,
	"fields": `h9ZpMyfbMEoPjI__QQzT`,
	"row": `iiZ7Kh0ArD0jgGA7ntCK`,
	"textField": `qDOT71J2AvMG0UocBOAu`
};
export default ___CSS_LOADER_EXPORT___;
